// Generated by npm run music:previews from reviewed originals.
export const MUSIC_PREVIEWS = [
  {
    "title": "Chills",
    "artist": "HoliznaCC0",
    "mood": "lofi",
    "url": "/music-previews/88cf8c964ea08b7eca07-v1.mp3",
    "durationS": 15,
    "sourceUrl": "https://opengameart.org/content/chills",
    "license": "CC0 1.0 Universal",
    "licenseUrl": "https://creativecommons.org/publicdomain/zero/1.0/"
  },
  {
    "title": "Poor, But Happy",
    "artist": "HoliznaCC0",
    "mood": "lofi",
    "url": "/music-previews/813e975208dfebca5ef0-v1.mp3",
    "durationS": 15,
    "sourceUrl": "https://opengameart.org/content/happy-lo-fi-lofi-collection",
    "license": "CC0 1.0 Universal",
    "licenseUrl": "https://creativecommons.org/publicdomain/zero/1.0/"
  },
  {
    "title": "Blue Skies",
    "artist": "HoliznaCC0",
    "mood": "calm",
    "url": "/music-previews/1b5916797fe6341663a7-v1.mp3",
    "durationS": 15,
    "sourceUrl": "https://opengameart.org/content/happy-lo-fi-lofi-collection",
    "license": "CC0 1.0 Universal",
    "licenseUrl": "https://creativecommons.org/publicdomain/zero/1.0/"
  },
  {
    "title": "Clouds",
    "artist": "HoliznaCC0",
    "mood": "calm",
    "url": "/music-previews/ae970bdaf997065c5b5e-v1.mp3",
    "durationS": 15,
    "sourceUrl": "https://opengameart.org/content/happy-lo-fi-lofi-collection",
    "license": "CC0 1.0 Universal",
    "licenseUrl": "https://creativecommons.org/publicdomain/zero/1.0/"
  },
  {
    "title": "Make Funk",
    "artist": "HoliznaCC0",
    "mood": "upbeat",
    "url": "/music-previews/4631f55b7fc2a021f24b-v1.mp3",
    "durationS": 15,
    "sourceUrl": "https://opengameart.org/content/funk-collection",
    "license": "CC0 1.0 Universal",
    "licenseUrl": "https://creativecommons.org/publicdomain/zero/1.0/"
  },
  {
    "title": "Happy Dance",
    "artist": "HoliznaCC0",
    "mood": "upbeat",
    "url": "/music-previews/75d7247e6025a9a0372a-v1.mp3",
    "durationS": 15,
    "sourceUrl": "https://opengameart.org/content/happy-pop-electronic-collection",
    "license": "CC0 1.0 Universal",
    "licenseUrl": "https://creativecommons.org/publicdomain/zero/1.0/"
  },
  {
    "title": "Earth",
    "artist": "HoliznaCC0",
    "mood": "corporate",
    "url": "/music-previews/b48e4c506b8cf4ecc05d-v1.mp3",
    "durationS": 15,
    "sourceUrl": "https://opengameart.org/content/happy-pop-electronic-collection",
    "license": "CC0 1.0 Universal",
    "licenseUrl": "https://creativecommons.org/publicdomain/zero/1.0/"
  },
  {
    "title": "A Small Town On Pluto",
    "artist": "HoliznaCC0",
    "mood": "corporate",
    "url": "/music-previews/1c645b9fccfcd21ae07e-v1.mp3",
    "durationS": 15,
    "sourceUrl": "https://opengameart.org/content/happy-pop-electronic-collection",
    "license": "CC0 1.0 Universal",
    "licenseUrl": "https://creativecommons.org/publicdomain/zero/1.0/"
  },
  {
    "title": "Drama",
    "artist": "HoliznaCC0",
    "mood": "dramatic",
    "url": "/music-previews/bacdf4eae1d6031a3578-v1.mp3",
    "durationS": 15,
    "sourceUrl": "https://opengameart.org/content/retro-wave-collection",
    "license": "CC0 1.0 Universal",
    "licenseUrl": "https://creativecommons.org/publicdomain/zero/1.0/"
  },
  {
    "title": "Cyber Anxiety",
    "artist": "HoliznaCC0",
    "mood": "dramatic",
    "url": "/music-previews/10c172f2fcc6cd889fcb-v1.mp3",
    "durationS": 15,
    "sourceUrl": "https://opengameart.org/content/retro-wave-collection",
    "license": "CC0 1.0 Universal",
    "licenseUrl": "https://creativecommons.org/publicdomain/zero/1.0/"
  },
  {
    "title": "All The Fight Left!",
    "artist": "HoliznaCC0",
    "mood": "epic",
    "url": "/music-previews/b6ce971879313d6a5011-v1.mp3",
    "durationS": 15,
    "sourceUrl": "https://opengameart.org/content/all-the-fight-left",
    "license": "CC0 1.0 Universal",
    "licenseUrl": "https://creativecommons.org/publicdomain/zero/1.0/"
  },
  {
    "title": "Lost In The Jungle",
    "artist": "HoliznaCC0",
    "mood": "epic",
    "url": "/music-previews/e50fd5b7f3275040ba24-v1.mp3",
    "durationS": 15,
    "sourceUrl": "https://opengameart.org/content/retro-wave-collection",
    "license": "CC0 1.0 Universal",
    "licenseUrl": "https://creativecommons.org/publicdomain/zero/1.0/"
  }
] as const;
